<template>
<div class=" animate_class">
<div class="grid custom_input_wrap mr-0 ml-0">

<template v-if="nonconformity_status=='loading'">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="nonconformity_status=='accepted'">
<div class="col-12">
<p class="text-green-500 font-bold">{{$store.state.languages.lang_phrases.son_dogrulama_kaydi_kabul_edildi_bu_soru_ile_ilgili_uygunsuzluk_kapatildi}}</p>
<p class="text-purple-500 underline" v-if="nonconformity.lastclosurerequest.resolvedby"><span class="font-bold">{{nonconformity.lastclosurerequest.resolvedby.name}}</span> tarafından</p>

<template v-if="!update_inputfield">  
 <Button  icon="pi pi-check" :label="$store.state.languages.lang_phrases.soru_duzenlemeyi_etkinlestir" @click="activateInputfieldCorrection(true)" class=" p-button-success p-button-outlined  p-button-sm" />  
</template>

<template v-if="update_inputfield">  
 <Button  icon="pi pi-check" :label="$store.state.languages.lang_phrases.soru_duzenlemeyi_kapat" @click="activateInputfieldCorrection(false)" class=" p-button-danger p-button-outlined  p-button-sm" />  
</template>

</div>
</template>

<template v-if="nonconformity_status=='pending'">
<div class="col-12">
<p class="text-red-700 font-bold">{{$store.state.languages.lang_phrases.son_dogrulama_kaydi_kontrol_edilmeyi_bekliyor}}</p>
<hr>
</div>
<div class="col-12">
<p class="font-bold text-primary">{{$store.state.languages.lang_phrases.son_dogrulama_kaydi}}</p>
<p class="text-purple-500 underline"><span class="font-bold">{{nonconformity.lastclosurerequest.submittedby.name}}</span> tarafından</p>
<p class="">{{nonconformity.lastclosurerequest.text}}</p>

</div>

<div class="col-12">
  <hr>
<ClickEditSelect title="Tür" :value="nonconformity.nonconformitytype_id" :options="nonconformitytypes" valkey="type" @dataChanged="nonconformityTypeChanged"   :color_selector="true" />

</div>

<div class="col-12 ">
<div class="flex align-items-center justify-content-end ">
<Button  icon="pi pi-times" :label="$store.state.languages.lang_phrases.reddet" @click="resolveNonconformity('false')" class=" p-button-danger p-button-outlined  p-button-sm" :loading="deleting"/> 
<Button  icon="pi pi-check"  :label="$store.state.languages.lang_phrases.kabul_et" @click="resolveNonconformity('true')" class=" p-button-success p-button-outlined  p-button-sm ml-2 " :loading="deleting"/> 
</div>
</div>

</template>


<template v-if="nonconformity_status=='rejected'">
<div class="col-12">
<p class="text-purple-500 font-bold">{{$store.state.languages.lang_phrases.son_dogrulama_kaydiniz_kontrol_edildi_ve_yeterli_bulunmadi}}</p>
</div>
</template>

<template v-if="nonconformity.evidences.length">
<p class="font-bold text-primary">{{$store.state.languages.lang_phrases.yuklenen_kanit_dosyalari}}</p>


<div class="col-12" v-for="item in nonconformity.evidences">
<div class="grid">
<div class="col-7" >
<a class="p-text-secondary" :href="apiurl+item.filepath" target="_blank">{{item.filename}}</a>
</div>

<div class="col-3" >
<small class="p-text-secondary fontt-bold" >{{ $filters.momentFormat( item.created_at," DD-MM-YYYY")}}</small>
</div>

<div class="col-2">
<Button  icon="pi pi-trash"  @click="deleteEvidence(item.id)" class=" p-button-danger p-button-outlined  p-button-sm" :loading="deleting"/> 
</div>

</div>
</div>


</template>

<template v-if="nonconformity_status=='awaiting' || nonconformity_status=='rejected'">
<div class="col-12">
<h4 class="text-primary mt-1">{{$store.state.languages.lang_phrases.henuz_yapilan_bir_kapatma_eylemi_bulunmuyor}}.</h4>
</div>
</template>


<template v-if="nonconformity_status=='awaiting' || nonconformity_status=='rejected'">
<h4 class="text-purple-500 mt-1">{{$store.state.languages.lang_phrases.tedarikci_adina_kapatma_ekleyin}}.</h4>
<div class="col-12">
<Textarea v-model="text" rows="3" autoResize  class="w-full p-inputtext-sm mb-0"  />
</div>

<div class="col-12 animate_class" v-show="showuploader">
<FileUpload name="cover_image[]" ref="cover_image" @select="onFilesAdded"  @remove="onFilesAdded"   v-model="files" :multiple="true" :showUploadButton="false" :showCancelButton="false" chooseLabel="Dosya Seçin"    :maxFileSize="10000000000" class="" :fileLimit="5">
  <template #empty>
      <div class="uploader_empty">
      <span class="material-icons-outlined md-48 mr-2">backup
    </span>
      <p>{{$store.state.languages.lang_phrases.dosyalari_buraysurukleyip_birakin}}</p>
    </div>
  </template>
</FileUpload>


</div>
<div class="col-12">
<div class="flex justify-content-end flex-wrap mt-3">
 <Button label="İptal" class=" p-button-danger p-button-outlined  p-button-sm" @click="hideUploader"  v-if="showuploader"></Button>
 <Button label="Kanıt Yükle" class=" p-button-info p-button-outlined  p-button-sm" @click="showUploader" v-if="!showuploader"></Button>

  <Button label="Kaydet" class=" p-button-primary p-button-outlined  p-button-sm ml-2" :loading="$store.state.ui.submitting" @click="submit"></Button>
</div>
</div>
</template>





</div>




<div class="grid custom_input_wrap mr-0 ml-0 mt-4" v-if="closurerequests">
<div class="col-12">
<p class="text-primary font-bold">{{$store.state.languages.lang_phrases.onceki_kapatma_talepleri}}</p>

<div class="grid" v-for="item in nonconformity.closurerequests">
<div class="col-12 md:col-8">
<p class="text-purple-500 mt-0 mb-0">{{item.submittedby.name}}</p>
</div>
<div class="col-12 md:col-4">
<div class="flex justify-content-end flex-wrap ">
<small class="p-text-secondary font-bold" >{{ $filters.momentFormat( item.created_at," DD-MM-YYYY")}}</small>
</div>
</div>

<template v-if="item.status=='rejected'">
<div class="col-12">
<small class="text-red-700 mt-0 mb-0"> <b>{{item.resolvedby.name}}</b> tarafından <b> {{ $filters.momentFormat( item.updated_at," DD-MM-YYYY")}}</b> tarihinde reddedildi</small>
</div>
<div class="col-12" v-if="item.rejectiontext" @dblclick="reviseRejectionText(item)">
<small class="text-pink-500 mt-0 mb-0 cursor-pointer"> <b>{{$store.state.languages.lang_phrases.red_sebebi}}: </b> {{item.rejectiontext}}</small>
</div>
</template>

<template v-if="item.status=='approved'">
<div class="col-12">
<small class="text-green-500 mt-0 mb-0"> <b>{{item.resolvedby.name}}</b> tarafından <b> {{ $filters.momentFormat( item.updated_at," DD-MM-YYYY")}}</b> tarihinde kabul edildi</small>
<hr>
</div>
</template>

<div class="col-12">
<p class="mt-0">{{item.text}}</p>
<hr>
</div>

</div>

</div>

</div>

<NonconformityRejectionModal  
:show="showrejectionmodal" 
@closeModal="closeRejectionModal" 
@nonconformityRejected="nonconformityRejected" 
ref="nonconformityrejectionmodal"
/>

</div>	
</template>

<script>
import NonconformityRejectionModal from "./NonconformityRejectionModal"
export default {

  name: 'NonconformityPanelForAdmin',
  props:["nonconformity","nonconformitytypes"],
  data () {
    return {
      text:null,
      files:[],
      showuploader:false,
      deleting:false,
      update_inputfield:false,
      showrejectionmodal:false,
    }
  },
  components:{NonconformityRejectionModal},
  computed:{
    closurerequests()
    {
      if(this.nonconformity.closurerequests.length)
      {
        return true
      }
      return false
    },
    nonconformity_status()
    {
      if(this.nonconformity )
      {
        if(this.nonconformity.status=="open")
        {
            if(this.nonconformity.lastclosurerequest)
            {
              if(this.nonconformity.lastclosurerequest.status=="pending")
              {
                return "pending"
              }
              if(this.nonconformity.lastclosurerequest.status=="rejected")
              {
                return "rejected"
              }
            }
            else
            {
              return "awaiting"
            }
        }
        else
        {
          return "accepted"
        }
        
      }

      return "loading"
    },
    apiurl()
    {
      let api =  process.env.VUE_APP_API_HOOK
      api = api.replace("/api/","/")
      //return api
      return "https://storage.googleapis.com/verifycloud/"
    },
  },
  methods:{
    activateInputfieldCorrection(val)
    {
      this.update_inputfield = val
      this.$emit("inputfieldcorrection",val)
    },
    deleteEvidence(id)
    {
      this.deleting = true
      let formdata = new FormData()
      this.generalSubmission(formdata,"delete_nonconformity_evidence/"+id,this.afterSubmit)
    },
    onFilesAdded(event)
    {
      this.files = []
      for(let file of event.files)
      {
        this.files.push(file)
      }
    },
    showUploader()
    {
      this.showuploader = true
    },
    hideUploader()
    {
      this.files = []
      //this.$refs.cover_image.value = ''
      this.showuploader = false
    },
    submit()
    {
      
      if(this.text=="" || !this.text)
      {
        this.has_error = true
        this.submitting = false
        return  false
      }
      let formdata = new FormData()
      formdata.append("text",this.text)
      formdata.append("flowsupplier_id",this.$route.params.id)
      for( var i = 0; i < this.files.length; i++ ){
        let file =  this.files[i];
        formdata.append('files[' + i + ']', file);
      }
      
      //return false
      this.generalSubmission(formdata,"submit_nonconformity_closure_request/"+this.nonconformity.id,this.afterSubmit)
    },
    afterSubmit(response)
    {
      this.deleting = false
      this.text = null
      this.files = []
      this.hideUploader()
      this.$emit("nonconformityDataUpdated",response.data)
      
    },
    nonconformityTypeChanged(data)
    {
      console.log(data)
      let formdata = new FormData()
      formdata.append("nonconformity_id",this.nonconformity.id)
      formdata.append("type",data.value)
      this.generalSubmission(formdata,"change_nonconformity_type/"+this.nonconformity.id,this.afterSubmit)
    },
    resolveNonconformity(type)
    {

      if(type=="true")
      {
        let formdata = new FormData()
        formdata.append("type",type)
        this.generalSubmission(formdata,"resolve_nonconformity/"+this.nonconformity.id,this.afterSubmit)
      }
      else
      {
        this.openRejectionModal()
      }
      
    },
    openRejectionModal()
    {
      this.$refs.nonconformityrejectionmodal.openModal()
    },
    closeRejectionModal()
    {
      this.$refs.nonconformityrejectionmodal.closeModal()
    },
    nonconformityRejected(response)
    {      
      this.afterSubmit(response)
    },
    reviseRejectionText(item)
    {
      this.$refs.nonconformityrejectionmodal.reviseRejectionText(item)
    },
  }
}
</script>

<style lang="css" scoped>
</style>